import { AnimatePeek, Container, LogoIcon, ScrollArea, Spinner } from '@qapline/ui';

import styles from './AuthPage.module.scss';

interface AuthPageProps {
    children?: React.ReactNode;
    isLoading?: boolean;
}

export const AuthPage = ({ children, isLoading }: AuthPageProps) => {
    return (
        <main className={styles.layout}>
            <ScrollArea className={styles.scrollArea}>
                {isLoading ? (
                    <Spinner fullScreen color="white" size={50} />
                ) : (
                    <Container size="medium" className={styles.container}>
                        <AnimatePeek>
                            <div className={styles.card}>
                                <LogoIcon />
                                {children}
                            </div>
                        </AnimatePeek>
                    </Container>
                )}
            </ScrollArea>
        </main>
    );
};
